export default "__VITE_ASSET__D0OKgn7I__"